<template>

<com-item name="games.arrivals" :size="size" :is-cards="true" :loading="loading" :is-empty="!active" :has-more="total > 5" v-on:more="onMore" :empty-cards="empty" title="First Encounters">

	<template v-slot:about>

		<p>The first time each game entered {{ your }} universe.</p>

	</template>

	<template v-slot:buttons>

		<com-toggle :options="typeOptions" :value="typeFilter" v-on:change="onTypeChange" />

	</template>

	<template v-slot:stats>

		<com-card v-for="(arrival, index) in data" :key="index" :item="gameData(arrival.g)" :date="arrival.date" :tag="arrival.type" :tag-theme="tagTheme(arrival.type)" :no-foot="true" v-on:click.native="goToGame(arrival.g)" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comCard from './../common/Card'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-card': comCard,
		'com-toggle': comToggle
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'arrivals.type'

		},

		data: function() {

			return this.$store.getters['page/insights/games/arrivals'] || []

		},

		total: function() {

			return this.$store.getters['page/insights/games/arrivalsTotal']

		},

		active: function() {

			return this.data && !this.loading && this.data.length

		},

		empty: function() {

			var count = 5 - this.data.length

			return (count > 0) ? count : 0

		},

		typeFilter: function() {

			return this.$store.getters['filter/insights/games/arrivals.type']

		},

		typeOptions: function() {

			return [
				{ value: 'all', text: 'All types' },
				{ value: 'Own', text: 'Own' },
				{ value: 'Previously Owned', text: 'Previously Owned' },
				{ value: 'Played', text: 'Played' },
				{ value: 'Rated', text: 'Rated' },
				{ value: 'Wishlisted', text: 'Wishlisted' }
			]

		}

	},

	methods: {

		gameData: function(id) {

			return this.$store.getters['data/games/associated'][id] || {}

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })

		},

		tagTheme: function(type) {

			return type || 'Own'

		},

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGamesArrivals'
			})

		},

		onTypeChange: function(value) {

			this.$store.commit('filter/insights/games/arrivals.type', value)

		}

	}

}

</script>

<style scoped>

</style>
